export default __webpack_public_path__ + "static/media/work2.357d6834.jpg";